<template lang="html">
  <div>
    <v-card-text>
      <v-row id="pegawai" style="position: sticky;top: 1px;z-index: 9999;">
        <v-col class="fixed" style="background-color: white;margin: 0px 0px 12px 12px;">
          <div class="ma-3 d-flex justify-center align-center flex-column">
            <v-avatar tile size="164"> <v-img :src="hasil.data_pegawai.foto"></v-img></v-avatar>
            <h3 class="mt-1 orange--text text--darken-2 headline">{{hasil.data_pegawai.nama_pegawai}}</h3>
            <div class="mt-1 grey--text">NIP. {{hasil.data_pegawai.nip_pegawai}}</div>
            <div class="mt-1 green--text">{{hasil.data_pegawai.jabatan}}</div>
          </div>
        </v-col>
        <v-col class="fixed" style="background-color: white;margin: 0px 12px 12px 0px;">
          <h2 class="display-2">Keterangan Pengisian</h2>
          <v-simple-table dense>
            <tbody>
              <tr  v-for="(ket,i) in keterangan" :key="i">
                <td>{{ket.isi}}</td>
                <td v-html="ket.ket"></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row class="not-fixed">
        <v-col>
          <div v-for="(v,k,i) in hasil.hasil_kusioner" :key="i" class="my-3">
            <h1 class="primary--text mt-4 mb-2 display-3 font-weight-bold" style="text-align:center;text-transform:uppercase">{{k}}</h1>
            <v-simple-table>
              <tbody>
                <template v-for="(item, j) in v">
                  <tr :key="j"><td style="font-size:1em">{{item.pertanyaan_kuesioner.nomor}}. <span v-html="item.pertanyaan_kuesioner.narasi"></span></td></tr>

                  <tr :key="j+'b'" class="blue--text text--darken-2"><td style="font-size:1em">
                    Nilai: {{item.nilai + 1}} - <span v-html="keteranganIdx(item.nilai)"></span>
                  </td></tr>
                </template>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
      <v-form>
        <v-row class="ma-3">
          <v-col cols=6>
            <h1 class="primary--text mt-4 mb-2 display-2 font-weight-bold" style="text-align:center;text-transform:uppercase">Kekuatan/Kelebihan Diri</h1>
            <h4 class="default--text mt-4 mb-2 " style="text-align:justify">{{hasil.komentar_strength ? hasil.komentar_strength : 'Tidak ada data.'}}</h4>
          </v-col>
          <v-col cols=6>
            <h1 class="primary--text mt-4 mb-2 display-2 font-weight-bold" style="text-align:center;text-transform:uppercase">Kelemahan/Kekurangan Diri</h1>
            <h4 class="default--text mt-4 mb-2 " style="text-align:justify">{{hasil.komentar_weakness ? hasil.komentar_weakness : 'Tidak ada data.'}}</h4>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </div>
</template>

<script>
export default {
  props:{
    hasil:Object,
    keterangan:Array,
  },
  methods:{
    keteranganIdx(idx){
      let i = idx
      if (idx > 5) i = 5
      else if (idx < 0) i = 0
      let ket = this.keterangan[i]
      return ket.ket
    }
  }
}
</script>

<style lang="css" scoped>
.fixed {
  position: sticky;
  width: 5em;
  left: 0;
  top: auto;
  z-index: 999;
}
.not-fixed{
  z-index: 0;
}
</style>
